import { memo } from 'react'

export const Footer = memo(() => {
  return <></>
})
Footer.displayName = 'Footer'
